function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 1,
  y1: 0.5,
  x2: 0.01,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#542493",
  stopOpacity: 0.749
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#542493"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#eef4fb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.311,
  stopColor: "#e3edf8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfe1f3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 0.505,
  y1: 1.222,
  x2: 0.483,
  y2: 0.189,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: 0.506,
  y1: -0.093,
  x2: 0.499,
  y2: 1.137,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#75769a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.968,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: 0.5,
  y1: -0.126,
  x2: 0.5,
  y2: 0.782,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: 0.503,
  y1: -0.506,
  x2: 0.498,
  y2: 0.945,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("radialGradient", {
  id: "g",
  cx: 0.422,
  cy: -0.337,
  r: 4.558,
  gradientTransform: "matrix(0.138, 0.052, -0.002, 0.237, 0.128, -0.265)",
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("path", {
  d: "M260.474,408.453l.585-222.819H654.943l-.585,222.819Z",
  transform: "translate(-260.474 -185.633)",
  fill: "none"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  y2: 0,
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: 0.501,
  y1: -2.81,
  x2: 0.499,
  y2: 2.933,
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 0.999,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "x",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 0.999,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "z",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ah",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ak",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 0.999,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "al",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "am",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "as",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ax",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "az",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ba",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bb",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "be",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bk",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bl",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bm",
  x1: 0.5,
  y1: 0,
  x2: 0.5,
  y2: 1,
  gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
  xlinkHref: "#g"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "by",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffd71d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fea000"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ca"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080,
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(178.537 587.28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.222,271.4q2.9-2.12,5.477-4.379a59.289,59.289,0,0,0,4.763-4.661,39.61,39.61,0,0,0,3.761-4.8,22.841,22.841,0,0,0,2.448-4.777,13.555,13.555,0,0,0,.863-4.645,11.3,11.3,0,0,0-.647-3.663,8.789,8.789,0,0,0-1.832-3.045,8.594,8.594,0,0,0-3.027-2.079,10.87,10.87,0,0,0-4.248-.766,12.7,12.7,0,0,0-3.411.482,21.421,21.421,0,0,0-3.382,1.247,22.736,22.736,0,0,0-3.061,1.732,16.419,16.419,0,0,0-2.432,1.963l-1.229-2.029a13.715,13.715,0,0,1,2.479-2.4,20.17,20.17,0,0,1,3.529-2.163,23.471,23.471,0,0,1,4.3-1.582,18.487,18.487,0,0,1,4.777-.616,16.311,16.311,0,0,1,5.908.966,12.065,12.065,0,0,1,4.113,2.561,10.144,10.144,0,0,1,2.413,3.648,11.721,11.721,0,0,1,.782,4.214A17.687,17.687,0,0,1,85.847,254a32.981,32.981,0,0,1-4.711,7.377,53.336,53.336,0,0,1-7.006,6.943,71.174,71.174,0,0,1-8.574,6.09l21.307-1.129,2.963-5.8,2.232.734-2.166,9.188H60.061l-.763-2.032Q62.325,273.515,65.222,271.4Z",
  transform: "translate(-59.266 -235.028)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.044,275.036q2.6-4.729,5.245-9.39t5.277-9.5q2.629-4.844,5.261-10.038t5.224-10.953h1.734l2.863,2.132q-.434.9-1.416,2.677t-2.3,4.163q-1.318,2.38-2.879,5.161t-3.195,5.627q-1.634,2.846-3.2,5.593t-2.9,5.079q-1.33,2.329-2.313,4.042t-1.416,2.513L78.473,274.6l19.344-.834.1-16.943,4.4-1.234v17.978l7.858-.366v4.329h-7.858v12.519H97.751l.066-12.519H74.876Z",
  transform: "translate(-35.152 -235.152)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.819,271.717a3.437,3.437,0,0,1-1.358-.279,3.2,3.2,0,0,1-1.163-.858,4.466,4.466,0,0,1-.808-1.463,6.429,6.429,0,0,1-.308-2.1,5.464,5.464,0,0,1,.374-2.05,4.955,4.955,0,0,1,1.024-1.613,4.658,4.658,0,0,1,1.526-1.053,4.711,4.711,0,0,1,1.887-.379,6.057,6.057,0,0,1,.855.061,4.25,4.25,0,0,1,.716.155v-2.769l-1.771-.3v-.724l2.995-.35.376.195v12.625h1.124v.626a2.712,2.712,0,0,1-.355.14,4.325,4.325,0,0,1-.45.116,4.125,4.125,0,0,1-.484.076c-.161.016-.316.024-.461.024-.1,0-.205-.008-.313-.018a.724.724,0,0,1-.295-.108.629.629,0,0,1-.221-.255,1.146,1.146,0,0,1-.087-.484v-.208a2.059,2.059,0,0,1-.366.316,2.738,2.738,0,0,1-.6.324,4.872,4.872,0,0,1-.821.255A4.694,4.694,0,0,1,69.819,271.717Zm.64-1.142a4.1,4.1,0,0,0,.495-.026,3.891,3.891,0,0,0,.429-.082,2.59,2.59,0,0,0,.7-.266,2.221,2.221,0,0,0,.482-.358v-6.366a2.027,2.027,0,0,0-.226-.226,1.563,1.563,0,0,0-.342-.216,2.241,2.241,0,0,0-.511-.161,3.314,3.314,0,0,0-.692-.063,2.918,2.918,0,0,0-.658.079,2.663,2.663,0,0,0-.674.261,2.889,2.889,0,0,0-.632.476,3.068,3.068,0,0,0-.537.711,4.123,4.123,0,0,0-.371.982,5.659,5.659,0,0,0-.153,1.287,5.979,5.979,0,0,0,.208,1.774,3.805,3.805,0,0,0,.605,1.234,2.492,2.492,0,0,0,.871.726A2.323,2.323,0,0,0,70.459,270.575Z",
  transform: "translate(-47.981 -197.886)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.3,266.327a2.069,2.069,0,0,1,.376-1.018,3.046,3.046,0,0,1,.782-.753,4.715,4.715,0,0,1,1.034-.526,8.839,8.839,0,0,1,1.147-.332,9.163,9.163,0,0,1,1.108-.174c.353-.034.661-.053.921-.053v-.721a2.762,2.762,0,0,0-.174-1.069,1.511,1.511,0,0,0-.484-.645,1.759,1.759,0,0,0-.724-.321,4.822,4.822,0,0,0-.9-.082,3.486,3.486,0,0,0-.542.047c-.2.032-.405.074-.618.129s-.429.121-.647.2a6.18,6.18,0,0,0-.616.258l-.308-.75a3.112,3.112,0,0,1,.753-.437,6.861,6.861,0,0,1,.918-.313,7.589,7.589,0,0,1,.913-.182,5.944,5.944,0,0,1,.761-.06,5.548,5.548,0,0,1,1.255.139,2.651,2.651,0,0,1,1.045.484,2.339,2.339,0,0,1,.711.929,3.71,3.71,0,0,1,.263,1.495l-.016,5.727h1.063v.547a2.778,2.778,0,0,1-.718.261,3.846,3.846,0,0,1-.863.1,2.988,2.988,0,0,1-.326-.021.844.844,0,0,1-.318-.105.64.64,0,0,1-.242-.258,1.015,1.015,0,0,1-.095-.482v-.234a2.657,2.657,0,0,1-.455.434,3.05,3.05,0,0,1-.6.35,3.583,3.583,0,0,1-.766.232,5.009,5.009,0,0,1-.953.084,2.9,2.9,0,0,1-1.179-.234,2.543,2.543,0,0,1-.882-.626,2.578,2.578,0,0,1-.629-2.021Zm1.616.034a2.326,2.326,0,0,0,.132.832,1.31,1.31,0,0,0,.389.553,1.575,1.575,0,0,0,.618.311,3.3,3.3,0,0,0,.826.095,2.022,2.022,0,0,0,.505-.066,3.772,3.772,0,0,0,.495-.166,3.327,3.327,0,0,0,.442-.229,1.881,1.881,0,0,0,.326-.255c0-.521,0-1.037.005-1.553s.008-1.029.013-1.55c-.234,0-.487.011-.766.037a6.5,6.5,0,0,0-.832.129,5.967,5.967,0,0,0-.808.242,2.832,2.832,0,0,0-.69.376,1.816,1.816,0,0,0-.479.537A1.4,1.4,0,0,0,71.911,266.362Z",
  transform: "translate(-41.298 -195.378)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.8,271.726a2.16,2.16,0,0,0,.329.068,3.244,3.244,0,0,0,.337.021,2.137,2.137,0,0,0,.647-.108,1.981,1.981,0,0,0,.711-.418,3.545,3.545,0,0,0,.692-.887,6.8,6.8,0,0,0,.613-1.5h-.358l-3.34-8.282-.866-.15v-.882h3.856v.882l-1.2.166,1.955,5.585.558,1.7.482-1.7,1.69-5.611-1.3-.14v-.882h3.6v.882l-.932.134q-.561,1.615-.979,2.84c-.282.813-.524,1.521-.732,2.119s-.387,1.108-.534,1.524-.268.763-.368,1.042-.182.5-.242.671-.113.308-.158.418c-.218.555-.434,1.053-.655,1.5a7.244,7.244,0,0,1-.692,1.155,3.954,3.954,0,0,1-.787.795,2.572,2.572,0,0,1-.937.44,3.036,3.036,0,0,1-.732.084c-.055,0-.118,0-.184-.008s-.132-.016-.195-.026a1.171,1.171,0,0,1-.171-.042.3.3,0,0,1-.108-.05Z",
  transform: "translate(-35.925 -195.273)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.766,266.664h.74l.326,1.016a3.625,3.625,0,0,0,.411.3,2.7,2.7,0,0,0,.416.213,3.009,3.009,0,0,0,.453.129,3.6,3.6,0,0,0,.534.053,3.4,3.4,0,0,0,.855-.071,1.842,1.842,0,0,0,.674-.284,1.323,1.323,0,0,0,.442-.492,1.52,1.52,0,0,0,.161-.716,1.025,1.025,0,0,0-.205-.642,2.03,2.03,0,0,0-.537-.476,4.94,4.94,0,0,0-.755-.395c-.284-.118-.574-.247-.868-.392-.329-.158-.647-.326-.961-.513a4.62,4.62,0,0,1-.832-.626,2.757,2.757,0,0,1-.579-.776,2.257,2.257,0,0,1-.053-1.771,2.161,2.161,0,0,1,.389-.626,2.642,2.642,0,0,1,.571-.476,3.821,3.821,0,0,1,.69-.342,3.911,3.911,0,0,1,.755-.208,4.735,4.735,0,0,1,.761-.082,5.721,5.721,0,0,1,.8.04,5.659,5.659,0,0,1,.724.129,4.266,4.266,0,0,1,.608.192,3.919,3.919,0,0,1,.463.216v1.782H83.04l-.355-.934a2.365,2.365,0,0,0-.255-.229,1.583,1.583,0,0,0-.308-.182,1.856,1.856,0,0,0-.387-.129,2.279,2.279,0,0,0-.49-.05,3.226,3.226,0,0,0-.737.079,1.793,1.793,0,0,0-.587.245,1.2,1.2,0,0,0-.395.434,1.367,1.367,0,0,0-.155.64,1.018,1.018,0,0,0,.182.653,2.094,2.094,0,0,0,.526.5,4.815,4.815,0,0,0,.745.424c.279.129.568.266.861.411s.613.292.926.445a4.124,4.124,0,0,1,.847.542,2.625,2.625,0,0,1,.611.732,1.991,1.991,0,0,1,.239,1,2.517,2.517,0,0,1-1.061,2.132,3.57,3.57,0,0,1-1.161.537,5.438,5.438,0,0,1-1.419.179,6.6,6.6,0,0,1-1.513-.179,5.364,5.364,0,0,1-1.39-.532Z",
  transform: "translate(-29.078 -195.445)",
  fill: "#3c3856"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(308.768 587.58)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M108.75,275.085l10.088-.7V241.193q-1.263.466-2.395.847c-.755.258-1.5.495-2.232.716s-1.476.432-2.232.634-1.553.411-2.4.632l-.5-2.563q1.5-.466,3.495-1.3t3.9-1.763q1.9-.932,3.411-1.782A14.864,14.864,0,0,0,122,235.266l1.766.5-.066,38.621,9.551.7v2.263h-24.5Z",
  transform: "translate(-108.75 -235.266)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.288,285.973a21.085,21.085,0,0,0,5.129-1.384,22.238,22.238,0,0,0,4.642-2.579,19.405,19.405,0,0,0,3.779-3.579,16.858,16.858,0,0,0,2.548-4.379,13.384,13.384,0,0,0,.932-4.958,14.614,14.614,0,0,0-.832-5.211,9.275,9.275,0,0,0-5.808-5.711,15.048,15.048,0,0,0-4.4-.782,22.315,22.315,0,0,0-5.027.432,34.325,34.325,0,0,0-5.345,1.518l-1.166-1L123.375,236h18.746l.932-.632h2.895l-1.263,4.761H127.07l-2.427,16.314a23.61,23.61,0,0,1,5.64-1.766,20.524,20.524,0,0,1,5.477-.25,16.342,16.342,0,0,1,4.945,1.25,12.212,12.212,0,0,1,6.727,7.024,15.974,15.974,0,0,1,.982,5.792,14.706,14.706,0,0,1-.834,4.792,20.148,20.148,0,0,1-2.345,4.7,23.885,23.885,0,0,1-3.682,4.261,24.667,24.667,0,0,1-4.808,3.461,26.356,26.356,0,0,1-5.711,2.316,23.956,23.956,0,0,1-6.424.847c-.555,0-1.134-.029-1.732-.084a9.047,9.047,0,0,1-1.863-.379l.032-2.466A17.94,17.94,0,0,0,126.288,285.973Z",
  transform: "translate(-89.175 -235.101)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.115,270.809l1.245-.174V259.366l-1.421-.3v-.724l2.629-.35.392.195-.016,3.677-.026,1.442a5.179,5.179,0,0,1,.795-.534,6.775,6.775,0,0,1,.861-.395,5.981,5.981,0,0,1,.845-.253,3.886,3.886,0,0,1,.747-.087,3.225,3.225,0,0,1,1.39.26,1.926,1.926,0,0,1,.853.795,3.788,3.788,0,0,1,.429,1.376,13.908,13.908,0,0,1,.108,2v4.171l1.247.174v.708H116.95v-.708l1.4-.174v-3.463c0-.645-.016-1.208-.047-1.7a3.986,3.986,0,0,0-.242-1.229,1.513,1.513,0,0,0-.584-.745,2.042,2.042,0,0,0-1.082-.25,5.75,5.75,0,0,0-.584.034,4.3,4.3,0,0,0-.618.113,4.5,4.5,0,0,0-.626.211,3.21,3.21,0,0,0-.6.342v6.685l1.224.174v.708h-4.069Z",
  transform: "translate(-105.178 -198.186)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.413,264.231a5.268,5.268,0,0,1,.387-1.992,4.5,4.5,0,0,1,.979-1.484,4.19,4.19,0,0,1,1.4-.934,4.485,4.485,0,0,1,1.661-.334,4.14,4.14,0,0,1,1.84.368,3.588,3.588,0,0,1,1.295,1.029,4.348,4.348,0,0,1,.761,1.534,6.635,6.635,0,0,1,.242,1.887,5.768,5.768,0,0,1-.355,2.024,4.94,4.94,0,0,1-.929,1.571,4.218,4.218,0,0,1-1.376,1.013,3.962,3.962,0,0,1-1.684.363,4.268,4.268,0,0,1-1.958-.416,3.691,3.691,0,0,1-1.313-1.116,4.724,4.724,0,0,1-.737-1.611A7.3,7.3,0,0,1,115.413,264.231Zm4.3,4.113a2.437,2.437,0,0,0,1.192-.242,2.033,2.033,0,0,0,.792-.761,3.731,3.731,0,0,0,.442-1.25,9.689,9.689,0,0,0,.137-1.711,7.979,7.979,0,0,0-.147-1.569,4.079,4.079,0,0,0-.458-1.268,2.479,2.479,0,0,0-.79-.855,2.159,2.159,0,0,0-1.134-.329,2.549,2.549,0,0,0-1.2.247,2.082,2.082,0,0,0-.813.745,3.523,3.523,0,0,0-.463,1.2,8.02,8.02,0,0,0-.145,1.608,7.574,7.574,0,0,0,.158,1.558,4.821,4.821,0,0,0,.476,1.324,2.78,2.78,0,0,0,.8.934A1.99,1.99,0,0,0,119.708,268.345Z",
  transform: "translate(-97.88 -195.745)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.22,260.877l-.858-.25v-.642l2.142-.458.289.153v5.735a8.414,8.414,0,0,0,.074,1.184,2.155,2.155,0,0,0,.276.816,1.206,1.206,0,0,0,.55.474,2.247,2.247,0,0,0,.9.155,2.688,2.688,0,0,0,.734-.1,5.081,5.081,0,0,0,.676-.25,3.86,3.86,0,0,0,.545-.308,2.265,2.265,0,0,0,.34-.282v-6.15l-1.04-.263V260l2.382-.476.232.142V268.3h1v.634a1.982,1.982,0,0,1-.308.126,3.656,3.656,0,0,1-.392.113c-.145.034-.289.063-.434.084a3,3,0,0,1-.421.032,1.038,1.038,0,0,1-.629-.168.647.647,0,0,1-.229-.545v-.684a5.507,5.507,0,0,1-1.519.961,4.058,4.058,0,0,1-1.553.329,3.2,3.2,0,0,1-1.532-.3,1.966,1.966,0,0,1-.818-.84,3.405,3.405,0,0,1-.332-1.271q-.067-.73-.074-1.6Z",
  transform: "translate(-91.434 -195.678)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.447,268.3l1.347-.174v-6.774l-1.182-.65v-.518l2.2-.658.392.168v1.282a2.356,2.356,0,0,1,.479-.49,4.454,4.454,0,0,1,.718-.471,4.827,4.827,0,0,1,.834-.35,2.669,2.669,0,0,1,.813-.139c.182,0,.35.005.5.013a1.125,1.125,0,0,1,.311.047v1.705l-.276-.105a2.6,2.6,0,0,0-.311-.089,2.858,2.858,0,0,0-.387-.06,4,4,0,0,0-.5-.026,3.252,3.252,0,0,0-1.129.168,4.634,4.634,0,0,0-.842.411V268.1l2.374.2v.708h-5.337Z",
  transform: "translate(-84.768 -195.678)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.575,266.664h.74l.326,1.016a3.641,3.641,0,0,0,.413.3,2.48,2.48,0,0,0,.416.213,2.923,2.923,0,0,0,.453.129,3.565,3.565,0,0,0,.534.053,3.414,3.414,0,0,0,.855-.071,1.842,1.842,0,0,0,.674-.284,1.345,1.345,0,0,0,.442-.492,1.52,1.52,0,0,0,.158-.716,1.024,1.024,0,0,0-.205-.642,1.989,1.989,0,0,0-.537-.476,4.82,4.82,0,0,0-.755-.395c-.282-.118-.574-.247-.866-.392-.329-.158-.647-.326-.961-.513a4.64,4.64,0,0,1-.834-.626,2.748,2.748,0,0,1-.576-.776,2.115,2.115,0,0,1-.208-.992,2.045,2.045,0,0,1,.153-.779,2.169,2.169,0,0,1,.392-.626,2.628,2.628,0,0,1,.568-.476,3.76,3.76,0,0,1,.692-.342,3.937,3.937,0,0,1,.753-.208,4.8,4.8,0,0,1,.761-.082,5.759,5.759,0,0,1,.805.04,5.616,5.616,0,0,1,.721.129,4.418,4.418,0,0,1,.611.192,4.131,4.131,0,0,1,.463.216v1.782h-.711l-.358-.934a2.115,2.115,0,0,0-.253-.229,1.688,1.688,0,0,0-.311-.182,1.829,1.829,0,0,0-.384-.129,2.305,2.305,0,0,0-.492-.05,3.243,3.243,0,0,0-.737.079,1.817,1.817,0,0,0-.587.245,1.228,1.228,0,0,0-.395.434,1.366,1.366,0,0,0-.155.64,1.036,1.036,0,0,0,.184.653,2.081,2.081,0,0,0,.524.5,5.077,5.077,0,0,0,.745.424q.422.193.861.411c.308.145.616.292.929.445a4.105,4.105,0,0,1,.845.542,2.635,2.635,0,0,1,.613.732,2.017,2.017,0,0,1,.237,1,2.517,2.517,0,0,1-1.061,2.132,3.556,3.556,0,0,1-1.158.537,5.438,5.438,0,0,1-1.419.179,6.623,6.623,0,0,1-1.516-.179,5.364,5.364,0,0,1-1.39-.532Z",
  transform: "translate(-79.664 -195.745)",
  fill: "#3c3856"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(432.615 587.48)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M161.765,271.4q2.9-2.12,5.477-4.379A59.284,59.284,0,0,0,172,262.361a39.613,39.613,0,0,0,3.761-4.8,22.966,22.966,0,0,0,2.448-4.777,13.555,13.555,0,0,0,.863-4.645,11.365,11.365,0,0,0-.647-3.663,8.789,8.789,0,0,0-1.832-3.045,8.594,8.594,0,0,0-3.027-2.079,10.87,10.87,0,0,0-4.248-.766,12.714,12.714,0,0,0-3.413.482,21.484,21.484,0,0,0-3.379,1.247,22.575,22.575,0,0,0-3.061,1.732,16.423,16.423,0,0,0-2.432,1.963l-1.229-2.029a13.714,13.714,0,0,1,2.479-2.4,20.17,20.17,0,0,1,3.529-2.163,23.471,23.471,0,0,1,4.3-1.582,18.487,18.487,0,0,1,4.777-.616,16.311,16.311,0,0,1,5.908.966,12.065,12.065,0,0,1,4.113,2.561,10.179,10.179,0,0,1,2.413,3.648,11.718,11.718,0,0,1,.779,4.214A17.683,17.683,0,0,1,182.39,254a32.981,32.981,0,0,1-4.711,7.377,53.337,53.337,0,0,1-7.006,6.943,71.382,71.382,0,0,1-8.574,6.09l21.307-1.129,2.963-5.8,2.232.734-2.166,9.188H156.6l-.763-2.032Q158.868,273.515,161.765,271.4Z",
  transform: "translate(-155.809 -235.228)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.871,262.939q4.812-11.752,9.8-24.1l-22.936.566-2.732,7.124-2.6-.266,1.6-10.853h29.728l1.068,1.2L184.894,287.64l-5.027-1.763Q185.059,274.689,189.871,262.939Z",
  transform: "translate(-130.353 -234.939)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.58,268.3l1.132-.184v-6.764l-1.184-.65v-.518l2.216-.658.376.168v1.19a4.7,4.7,0,0,1,.666-.479,6.9,6.9,0,0,1,.834-.429,6.222,6.222,0,0,1,.913-.311,4.438,4.438,0,0,1,.89-.139,3.1,3.1,0,0,1,1.45.24,1.841,1.841,0,0,1,.863.945,4.628,4.628,0,0,1,.708-.432,7.57,7.57,0,0,1,.855-.371,7.722,7.722,0,0,1,.908-.263,5.351,5.351,0,0,1,.858-.118,3.241,3.241,0,0,1,1.305.195,1.826,1.826,0,0,1,.858.7,3.275,3.275,0,0,1,.466,1.25,10.216,10.216,0,0,1,.142,1.837v4.621l1.408.174v.708h-4.137V268.3l1.132-.174V263.8a11.134,11.134,0,0,0-.074-1.387,2.6,2.6,0,0,0-.295-.963,1.346,1.346,0,0,0-.613-.555,2.331,2.331,0,0,0-1.024-.15,4.093,4.093,0,0,0-1.124.213,6.258,6.258,0,0,0-1.1.495,8.129,8.129,0,0,1,.142.911c.032.342.047.695.047,1.063v4.711l1.274.166v.708h-4.121V268.3l1.25-.184v-4.45a9.563,9.563,0,0,0-.082-1.358,2.235,2.235,0,0,0-.3-.924,1.248,1.248,0,0,0-.618-.513,2.619,2.619,0,0,0-1.029-.129,3.784,3.784,0,0,0-1.026.229,5.346,5.346,0,0,0-1.211.637v1.524c0,.84,0,1.669-.008,2.5s-.008,1.661,0,2.5l1.237.174v.708H156.58Z",
  transform: "translate(-154.637 -195.579)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.044,270.906l1.413-.174v-6.819l-1.15-.605v-.518l2.305-.658.376.168v8.432l1.35.174v.708h-4.3Zm1.837-10.738a1.18,1.18,0,0,1-.39-.068,1.167,1.167,0,0,1-.337-.2.965.965,0,0,1-.234-.321,1.1,1.1,0,0,1,.026-.916,1.324,1.324,0,0,1,.287-.39,1.289,1.289,0,0,1,.395-.25,1.122,1.122,0,0,1,.445-.092.983.983,0,0,1,.8.3,1.088,1.088,0,0,1,.255.726,1.163,1.163,0,0,1-.108.5,1.236,1.236,0,0,1-.284.376,1.3,1.3,0,0,1-.4.242A1.222,1.222,0,0,1,164.881,260.168Z",
  transform: "translate(-144.003 -198.182)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165.349,268.3l1.132-.166v-6.782l-1.182-.65v-.518l2.216-.658.374.168v1.19a5.081,5.081,0,0,1,.682-.479,7.551,7.551,0,0,1,.85-.429,6.244,6.244,0,0,1,.924-.311,4.6,4.6,0,0,1,.9-.139,3.239,3.239,0,0,1,1.3.189,1.821,1.821,0,0,1,.847.69,3.217,3.217,0,0,1,.468,1.229,10.05,10.05,0,0,1,.139,1.8v4.7l1.34.166v.708h-4.2V268.3l1.258-.174v-4.4a10.986,10.986,0,0,0-.074-1.334,2.542,2.542,0,0,0-.3-.947,1.317,1.317,0,0,0-.611-.55,2.35,2.35,0,0,0-1.026-.15,3.864,3.864,0,0,0-1.09.229,5.431,5.431,0,0,0-1.205.637v6.519l1.24.174v.708h-3.987Z",
  transform: "translate(-140.324 -195.579)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.539,260.877l-.858-.25v-.642l2.14-.458.289.153v5.735a8,8,0,0,0,.076,1.184,2.11,2.11,0,0,0,.274.816,1.206,1.206,0,0,0,.55.474,2.246,2.246,0,0,0,.9.155,2.66,2.66,0,0,0,.734-.1,5.085,5.085,0,0,0,.676-.25,3.719,3.719,0,0,0,.545-.308,2.023,2.023,0,0,0,.34-.282v-6.15l-1.037-.263V260l2.379-.476.234.142V268.3h1v.634a2.14,2.14,0,0,1-.311.126,3.331,3.331,0,0,1-.392.113c-.145.034-.287.063-.434.084a2.964,2.964,0,0,1-.418.032,1.027,1.027,0,0,1-.629-.168.64.64,0,0,1-.229-.545v-.684a5.545,5.545,0,0,1-1.519.961,4.078,4.078,0,0,1-1.553.329,3.193,3.193,0,0,1-1.532-.3,1.957,1.957,0,0,1-.821-.84,3.509,3.509,0,0,1-.332-1.271q-.063-.73-.071-1.6Z",
  transform: "translate(-133.173 -195.578)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.066,268.1c0-1.024,0-2.037.005-3.042s0-2.024,0-3.045H173.8v-.624c.242-.061.447-.108.611-.145a2.054,2.054,0,0,0,.405-.126.822.822,0,0,0,.274-.179.972.972,0,0,0,.2-.316c.039-.092.087-.232.147-.416s.113-.371.166-.561.1-.374.137-.542.063-.29.074-.363h.826v2.224h2.795v1.047H176.64v4.2c0,.645.008,1.166.026,1.571a3.992,3.992,0,0,0,.121.942.777.777,0,0,0,.295.463,1,1,0,0,0,.532.121,2.769,2.769,0,0,0,.463-.042c.168-.029.332-.06.49-.1s.3-.082.437-.129a1.194,1.194,0,0,0,.3-.14l.258.734a1.79,1.79,0,0,1-.508.366,4.015,4.015,0,0,1-.687.268,5.315,5.315,0,0,1-.74.161,4.5,4.5,0,0,1-.653.055,1.793,1.793,0,0,1-1.408-.558A2.7,2.7,0,0,1,175.066,268.1Z",
  transform: "translate(-126.447 -196.852)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.523,264.448a5.581,5.581,0,0,1,.337-1.963,4.639,4.639,0,0,1,.942-1.555,4.336,4.336,0,0,1,1.45-1.037,4.881,4.881,0,0,1,1.874-.405,3.432,3.432,0,0,1,1.324.213,2.649,2.649,0,0,1,1.008.679,3.245,3.245,0,0,1,.653,1.1,4.929,4.929,0,0,1,.271,1.474,7.011,7.011,0,0,1-.021.908c-.026.255-.053.482-.079.682h-6.169v.095a.41.41,0,0,0,.011.1,4.286,4.286,0,0,0,.339,1.663,2.984,2.984,0,0,0,.771,1.047,2.724,2.724,0,0,0,1.019.539,4.09,4.09,0,0,0,1.09.153,6.167,6.167,0,0,0,.682-.037,6.552,6.552,0,0,0,.7-.108,5.963,5.963,0,0,0,.624-.163,2.611,2.611,0,0,0,.463-.189l.305.708a2.413,2.413,0,0,1-.626.39,5.13,5.13,0,0,1-.845.295,7.351,7.351,0,0,1-.958.184,7.778,7.778,0,0,1-.974.063,4.356,4.356,0,0,1-1.787-.347,3.61,3.61,0,0,1-1.311-.974,4.345,4.345,0,0,1-.811-1.518A6.707,6.707,0,0,1,176.523,264.448Zm6.158-.89c.018-.282.021-.568.013-.853a4.069,4.069,0,0,0-.1-.816,2.581,2.581,0,0,0-.279-.708,1.489,1.489,0,0,0-.505-.518,1.616,1.616,0,0,0-.49-.213,2.52,2.52,0,0,0-.626-.071,2.353,2.353,0,0,0-.9.176,2.038,2.038,0,0,0-.782.555,3.18,3.18,0,0,0-.582.987,5.128,5.128,0,0,0-.3,1.461Z",
  transform: "translate(-122.009 -195.645)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.392,266.664h.74l.326,1.016a3.626,3.626,0,0,0,.411.3,2.7,2.7,0,0,0,.416.213,3.009,3.009,0,0,0,.453.129,3.6,3.6,0,0,0,.534.053,3.4,3.4,0,0,0,.855-.071,1.842,1.842,0,0,0,.674-.284,1.322,1.322,0,0,0,.442-.492,1.52,1.52,0,0,0,.161-.716,1.041,1.041,0,0,0-.205-.642,2.03,2.03,0,0,0-.537-.476,4.943,4.943,0,0,0-.755-.395c-.284-.118-.574-.247-.868-.392-.329-.158-.647-.326-.961-.513a4.617,4.617,0,0,1-.832-.626,2.756,2.756,0,0,1-.579-.776,2.114,2.114,0,0,1-.208-.992,2.046,2.046,0,0,1,.155-.779,2.161,2.161,0,0,1,.389-.626,2.642,2.642,0,0,1,.571-.476,3.82,3.82,0,0,1,.689-.342,3.911,3.911,0,0,1,.755-.208,4.735,4.735,0,0,1,.761-.082,5.721,5.721,0,0,1,.8.04,5.661,5.661,0,0,1,.724.129,4.268,4.268,0,0,1,.608.192,3.919,3.919,0,0,1,.463.216v1.782h-.711l-.355-.934a2.362,2.362,0,0,0-.255-.229,1.582,1.582,0,0,0-.308-.182,1.856,1.856,0,0,0-.387-.129,2.279,2.279,0,0,0-.49-.05,3.21,3.21,0,0,0-.737.079,1.792,1.792,0,0,0-.587.245,1.236,1.236,0,0,0-.4.434,1.366,1.366,0,0,0-.153.64,1.018,1.018,0,0,0,.182.653,2.081,2.081,0,0,0,.524.5,4.975,4.975,0,0,0,.747.424q.418.193.861.411c.305.145.613.292.926.445a4.194,4.194,0,0,1,.847.542,2.67,2.67,0,0,1,.611.732,1.991,1.991,0,0,1,.24,1,2.535,2.535,0,0,1-1.061,2.132,3.57,3.57,0,0,1-1.161.537,5.438,5.438,0,0,1-1.419.179,6.6,6.6,0,0,1-1.513-.179,5.329,5.329,0,0,1-1.39-.532Z",
  transform: "translate(-115.695 -195.645)",
  fill: "#3c3856"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(559.225 587.345)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.242,275.085l10.088-.7V241.193q-1.263.466-2.395.847c-.755.258-1.5.495-2.232.716s-1.476.432-2.229.634-1.555.411-2.4.632l-.5-2.563q1.5-.466,3.495-1.3t3.9-1.763q1.895-.932,3.411-1.782a14.952,14.952,0,0,0,2.113-1.347l1.766.5-.066,38.621,9.553.7v2.263h-24.5Z",
  transform: "translate(-201.755 -235.032)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.411,285.249a25.128,25.128,0,0,0,6.324.316,21.993,21.993,0,0,0,5.477-1.129,18.257,18.257,0,0,0,4.5-2.282,16.344,16.344,0,0,0,3.379-3.148,13.259,13.259,0,0,0,2.132-3.745,11.681,11.681,0,0,0,.732-4.061,11.89,11.89,0,0,0-.732-4.261,7.784,7.784,0,0,0-2.3-3.245,9.933,9.933,0,0,0-4.027-1.934,19.433,19.433,0,0,0-5.927-.382l-5.027,1.134v-3.466a27.91,27.91,0,0,0,6.29-1.729,19.876,19.876,0,0,0,4.763-2.729,12.192,12.192,0,0,0,3.026-3.413,7.684,7.684,0,0,0,1.1-3.745,10.259,10.259,0,0,0-.632-3.963,7.092,7.092,0,0,0-1.9-2.748,7.845,7.845,0,0,0-2.911-1.595,12.351,12.351,0,0,0-3.645-.518,16.086,16.086,0,0,0-3.813.419,15.317,15.317,0,0,0-3.061,1.063,16.4,16.4,0,0,0-2.4,1.4q-1.05.754-1.85,1.384l-1.432-2.366a16.753,16.753,0,0,1,2.113-1.732,18.048,18.048,0,0,1,3.132-1.729,23.488,23.488,0,0,1,4.092-1.332,21.883,21.883,0,0,1,4.979-.534,17.484,17.484,0,0,1,4.561.6,11.536,11.536,0,0,1,3.979,1.913,9.786,9.786,0,0,1,2.811,3.379,10.669,10.669,0,0,1,1.068,4.961,9.86,9.86,0,0,1-.95,4.1,16.358,16.358,0,0,1-2.5,3.913,18.821,18.821,0,0,1-3.577,3.227,14.406,14.406,0,0,1-4.163,2.05,18.431,18.431,0,0,1,6.174.632,11.538,11.538,0,0,1,4.379,2.332,9.742,9.742,0,0,1,2.6,3.613,11.53,11.53,0,0,1,.866,4.477,14.836,14.836,0,0,1-.9,5.061,17.488,17.488,0,0,1-2.595,4.711,20.284,20.284,0,0,1-4.129,3.992,21.864,21.864,0,0,1-5.508,2.9,26.9,26.9,0,0,1-6.727,1.45,28.946,28.946,0,0,1-7.74-.4c0-.421-.005-.89-.016-1.413S218.411,285.67,218.411,285.249Z",
  transform: "translate(-183.419 -235.177)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M203.917,266.664h.74l.326,1.016a3.874,3.874,0,0,0,.411.3,2.608,2.608,0,0,0,.418.213,2.84,2.84,0,0,0,.453.129,3.53,3.53,0,0,0,.534.053,3.414,3.414,0,0,0,.855-.071,1.882,1.882,0,0,0,.674-.284,1.346,1.346,0,0,0,.442-.492,1.521,1.521,0,0,0,.158-.716,1.024,1.024,0,0,0-.205-.642,2.029,2.029,0,0,0-.537-.476,4.94,4.94,0,0,0-.755-.395c-.284-.118-.574-.247-.866-.392-.329-.158-.647-.326-.961-.513a4.55,4.55,0,0,1-.834-.626,2.758,2.758,0,0,1-.579-.776,2.147,2.147,0,0,1-.208-.992,2.1,2.1,0,0,1,.155-.779,2.218,2.218,0,0,1,.389-.626,2.706,2.706,0,0,1,.571-.476,3.758,3.758,0,0,1,.692-.342,3.885,3.885,0,0,1,.753-.208,4.768,4.768,0,0,1,.761-.082,5.76,5.76,0,0,1,.805.04,5.7,5.7,0,0,1,.721.129,4.418,4.418,0,0,1,.611.192,3.867,3.867,0,0,1,.461.216v1.782h-.708l-.358-.934a1.947,1.947,0,0,0-.255-.229,1.582,1.582,0,0,0-.308-.182,1.883,1.883,0,0,0-.384-.129,2.305,2.305,0,0,0-.492-.05,3.243,3.243,0,0,0-.737.079,1.818,1.818,0,0,0-.587.245,1.229,1.229,0,0,0-.395.434,1.366,1.366,0,0,0-.155.64,1.02,1.02,0,0,0,.184.653,2.037,2.037,0,0,0,.524.5,5.078,5.078,0,0,0,.745.424c.279.129.568.266.861.411s.616.292.929.445a4.177,4.177,0,0,1,.845.542,2.581,2.581,0,0,1,.611.732,1.991,1.991,0,0,1,.24,1,2.517,2.517,0,0,1-1.061,2.132,3.581,3.581,0,0,1-1.158.537,5.444,5.444,0,0,1-1.421.179,6.617,6.617,0,0,1-1.513-.179,5.363,5.363,0,0,1-1.39-.532Z",
  transform: "translate(-203.917 -195.511)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.049,264.448a5.582,5.582,0,0,1,.337-1.963,4.677,4.677,0,0,1,.94-1.555,4.322,4.322,0,0,1,1.453-1.037,4.87,4.87,0,0,1,1.874-.405,3.448,3.448,0,0,1,1.324.213,2.69,2.69,0,0,1,1.008.679,3.332,3.332,0,0,1,.653,1.1,5.016,5.016,0,0,1,.268,1.474,7.007,7.007,0,0,1-.021.908c-.024.255-.05.482-.079.682h-6.169v.095a.41.41,0,0,0,.011.1,4.285,4.285,0,0,0,.339,1.663,3.016,3.016,0,0,0,.771,1.047,2.715,2.715,0,0,0,1.021.539,4.061,4.061,0,0,0,1.09.153,6.169,6.169,0,0,0,.682-.037,6.611,6.611,0,0,0,.695-.108,6.2,6.2,0,0,0,.626-.163,2.575,2.575,0,0,0,.461-.189l.308.708a2.479,2.479,0,0,1-.629.39,5.046,5.046,0,0,1-.845.295,7.228,7.228,0,0,1-.955.184,7.778,7.778,0,0,1-.974.063,4.348,4.348,0,0,1-1.787-.347,3.609,3.609,0,0,1-1.311-.974,4.349,4.349,0,0,1-.813-1.518A6.707,6.707,0,0,1,207.049,264.448Zm6.158-.89c.016-.282.018-.568.013-.853a4.072,4.072,0,0,0-.105-.816,2.5,2.5,0,0,0-.279-.708,1.481,1.481,0,0,0-.5-.518,1.661,1.661,0,0,0-.492-.213,2.483,2.483,0,0,0-.624-.071,2.366,2.366,0,0,0-.9.176,2.058,2.058,0,0,0-.782.555,3.178,3.178,0,0,0-.582.987,5.314,5.314,0,0,0-.3,1.461Z",
  transform: "translate(-198.806 -195.511)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.718,264.585a5.689,5.689,0,0,1,.342-2.074,4.711,4.711,0,0,1,.961-1.582,4.332,4.332,0,0,1,1.44-1.024,4.956,4.956,0,0,1,1.784-.408c.232-.005.471,0,.713.013a6.52,6.52,0,0,1,.682.074,4.717,4.717,0,0,1,.587.137,1.862,1.862,0,0,1,.432.192v2h-.79l-.424-1.047a1.24,1.24,0,0,0-.31-.184,2.853,2.853,0,0,0-.355-.126,2.56,2.56,0,0,0-.366-.068,2.611,2.611,0,0,0-.334-.021,2.818,2.818,0,0,0-1.066.208,2.507,2.507,0,0,0-.9.629,2.994,2.994,0,0,0-.624,1.055,4.415,4.415,0,0,0-.242,1.495,5.9,5.9,0,0,0,.266,1.94,3.957,3.957,0,0,0,.716,1.321,2.76,2.76,0,0,0,.982.747,2.652,2.652,0,0,0,1.066.237,5.48,5.48,0,0,0,.674-.042c.234-.029.458-.063.674-.108a4.4,4.4,0,0,0,.6-.161,2.633,2.633,0,0,0,.447-.2l.287.742a2.519,2.519,0,0,1-.6.382,4.749,4.749,0,0,1-.787.282,6.65,6.65,0,0,1-.895.182,7.167,7.167,0,0,1-.947.061,3.971,3.971,0,0,1-1.705-.347,3.539,3.539,0,0,1-1.253-.976,4.321,4.321,0,0,1-.779-1.476A6.383,6.383,0,0,1,210.718,264.585Z",
  transform: "translate(-192.819 -195.496)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M214.051,264.231a5.269,5.269,0,0,1,.384-1.992,4.587,4.587,0,0,1,.979-1.484,4.2,4.2,0,0,1,1.4-.934,4.482,4.482,0,0,1,1.658-.334,4.151,4.151,0,0,1,1.842.368,3.588,3.588,0,0,1,1.295,1.029,4.393,4.393,0,0,1,.761,1.534,6.731,6.731,0,0,1,.242,1.887,5.768,5.768,0,0,1-.355,2.024,4.9,4.9,0,0,1-.932,1.571,4.181,4.181,0,0,1-1.374,1.013,3.965,3.965,0,0,1-1.687.363,4.249,4.249,0,0,1-1.955-.416A3.691,3.691,0,0,1,215,267.745a4.628,4.628,0,0,1-.737-1.611A7.19,7.19,0,0,1,214.051,264.231Zm4.3,4.113a2.444,2.444,0,0,0,1.192-.242,2.026,2.026,0,0,0,.789-.761,3.673,3.673,0,0,0,.442-1.25,9.437,9.437,0,0,0,.137-1.711,7.987,7.987,0,0,0-.145-1.569,4.146,4.146,0,0,0-.458-1.268,2.478,2.478,0,0,0-.789-.855,2.169,2.169,0,0,0-1.137-.329,2.556,2.556,0,0,0-1.2.247,2.074,2.074,0,0,0-.811.745,3.522,3.522,0,0,0-.463,1.2,8,8,0,0,0-.147,1.608,7.579,7.579,0,0,0,.161,1.558,4.819,4.819,0,0,0,.474,1.324,2.816,2.816,0,0,0,.8.934A1.99,1.99,0,0,0,218.346,268.345Z",
  transform: "translate(-187.383 -195.51)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.119,268.3l1.132-.166v-6.782l-1.184-.65v-.518l2.216-.658.376.168v1.19a5.085,5.085,0,0,1,.682-.479,7.332,7.332,0,0,1,.85-.429,6.213,6.213,0,0,1,.921-.311,4.626,4.626,0,0,1,.9-.139,3.239,3.239,0,0,1,1.3.189,1.828,1.828,0,0,1,.85.69,3.216,3.216,0,0,1,.466,1.229,10.029,10.029,0,0,1,.142,1.8v4.7l1.34.166v.708h-4.2V268.3l1.258-.174v-4.4a10.444,10.444,0,0,0-.076-1.334,2.5,2.5,0,0,0-.295-.947,1.342,1.342,0,0,0-.611-.55,2.35,2.35,0,0,0-1.026-.15,3.846,3.846,0,0,0-1.09.229,5.374,5.374,0,0,0-1.205.637v6.519l1.24.174v.708h-3.987Z",
  transform: "translate(-180.829 -195.445)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.05,271.717a3.437,3.437,0,0,1-1.358-.279,3.193,3.193,0,0,1-1.161-.858,4.422,4.422,0,0,1-.811-1.463,6.43,6.43,0,0,1-.308-2.1,5.414,5.414,0,0,1,.376-2.05,4.906,4.906,0,0,1,1.021-1.613,4.692,4.692,0,0,1,3.413-1.432,6.057,6.057,0,0,1,.855.061,4.228,4.228,0,0,1,.719.155v-2.769l-1.774-.3v-.724l3-.35.374.195v12.625h1.124v.626a2.447,2.447,0,0,1-.355.14,4.01,4.01,0,0,1-.45.116,4.08,4.08,0,0,1-.482.076c-.163.016-.316.024-.461.024-.1,0-.205-.008-.313-.018a.749.749,0,0,1-.3-.108.606.606,0,0,1-.218-.255,1.1,1.1,0,0,1-.089-.484v-.208a2.127,2.127,0,0,1-.363.316,2.826,2.826,0,0,1-.6.324,4.839,4.839,0,0,1-.818.255A4.737,4.737,0,0,1,226.05,271.717Zm.64-1.142a4.175,4.175,0,0,0,.5-.026,4.015,4.015,0,0,0,.429-.082,2.605,2.605,0,0,0,.7-.266,2.311,2.311,0,0,0,.484-.358v-6.366a2.605,2.605,0,0,0-.226-.226,1.526,1.526,0,0,0-.345-.216,2.259,2.259,0,0,0-.508-.161,3.341,3.341,0,0,0-.695-.063,2.936,2.936,0,0,0-.658.079,2.663,2.663,0,0,0-.674.261,2.889,2.889,0,0,0-.632.476,3.06,3.06,0,0,0-.534.711,4.014,4.014,0,0,0-.374.982,5.519,5.519,0,0,0-.15,1.287,5.9,5.9,0,0,0,.208,1.774,3.751,3.751,0,0,0,.6,1.234,2.492,2.492,0,0,0,.871.726A2.323,2.323,0,0,0,226.69,270.575Z",
  transform: "translate(-173.736 -197.951)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M226.674,266.664h.74l.326,1.016a3.88,3.88,0,0,0,.411.3,2.613,2.613,0,0,0,.418.213,2.891,2.891,0,0,0,.45.129,3.6,3.6,0,0,0,.537.053,3.414,3.414,0,0,0,.855-.071,1.882,1.882,0,0,0,.674-.284,1.369,1.369,0,0,0,.442-.492,1.52,1.52,0,0,0,.158-.716,1.025,1.025,0,0,0-.205-.642,2.029,2.029,0,0,0-.537-.476,4.943,4.943,0,0,0-.755-.395c-.284-.118-.574-.247-.866-.392-.329-.158-.647-.326-.963-.513a4.62,4.62,0,0,1-.832-.626,2.758,2.758,0,0,1-.579-.776,2.148,2.148,0,0,1-.208-.992,2.1,2.1,0,0,1,.155-.779,2.217,2.217,0,0,1,.39-.626,2.7,2.7,0,0,1,.571-.476,3.76,3.76,0,0,1,.692-.342,3.835,3.835,0,0,1,.753-.208,4.736,4.736,0,0,1,.761-.082,5.779,5.779,0,0,1,.805.04,5.7,5.7,0,0,1,.721.129,4.266,4.266,0,0,1,.608.192,3.917,3.917,0,0,1,.463.216v1.782h-.708l-.358-.934a2.133,2.133,0,0,0-.255-.229,1.581,1.581,0,0,0-.308-.182,1.882,1.882,0,0,0-.384-.129,2.323,2.323,0,0,0-.492-.05,3.226,3.226,0,0,0-.737.079,1.817,1.817,0,0,0-.587.245,1.229,1.229,0,0,0-.395.434,1.367,1.367,0,0,0-.155.64,1.035,1.035,0,0,0,.182.653,2.094,2.094,0,0,0,.526.5,4.942,4.942,0,0,0,.745.424c.279.129.568.266.861.411s.613.292.929.445a4.175,4.175,0,0,1,.845.542,2.581,2.581,0,0,1,.611.732,1.991,1.991,0,0,1,.24,1,2.517,2.517,0,0,1-1.061,2.132A3.57,3.57,0,0,1,231,269.1a5.423,5.423,0,0,1-1.419.179,6.618,6.618,0,0,1-1.513-.179,5.363,5.363,0,0,1-1.39-.532Z",
  transform: "translate(-166.783 -195.511)",
  fill: "#3c3856"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(177 702.164)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M369.531,278.8H72.641a13.958,13.958,0,1,0,0,27.915h296.89Z",
  transform: "translate(-58.682 -278.805)",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M495.495,281.437a11.326,11.326,0,0,1,0,22.652H72.641a11.326,11.326,0,1,1,0-22.652Zm0-2.632H72.641a13.958,13.958,0,1,0,0,27.915H495.495a13.958,13.958,0,0,0,0-27.915Z",
  transform: "translate(-58.682 -278.805)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(328.155 6.719)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M189.162,284.654a2.429,2.429,0,0,0-1.511-.732,2.233,2.233,0,0,0-1.147.279,2.457,2.457,0,0,0-.811.832,5.974,5.974,0,0,0-.711,3.177q0,1.982.926,2.474a1.291,1.291,0,0,0,.611.155,2.691,2.691,0,0,0,.561-.053,2.257,2.257,0,0,0,.479-.155,6.268,6.268,0,0,0,1.071-.663l.3.624a3.831,3.831,0,0,1-1.8,1.171,3.394,3.394,0,0,1-1.05.147,2.616,2.616,0,0,1-1.113-.237,2.331,2.331,0,0,1-.868-.682,4.025,4.025,0,0,1-.724-2.553,6.529,6.529,0,0,1,1.163-3.716,4.388,4.388,0,0,1,2.013-1.679,3.557,3.557,0,0,1,1.366-.255,3.612,3.612,0,0,1,1.695.371Z",
  transform: "translate(-183.372 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M187.765,291.67q-1.761-.746-1.758-3.44a6.131,6.131,0,0,1,1.195-3.7,4.217,4.217,0,0,1,1.95-1.519,3.474,3.474,0,0,1,1.269-.224,3.155,3.155,0,0,1,1.253.24,2.547,2.547,0,0,1,.955.695,4.024,4.024,0,0,1,.811,2.69,6.15,6.15,0,0,1-1.195,3.755,4.389,4.389,0,0,1-1.958,1.526,3.6,3.6,0,0,1-1.271.216A3.142,3.142,0,0,1,187.765,291.67Zm.824-.887a1.452,1.452,0,0,0,.747.187,1.551,1.551,0,0,0,.79-.208,2.2,2.2,0,0,0,.642-.555,3.746,3.746,0,0,0,.49-.81,7.274,7.274,0,0,0,.571-2.937q0-1.99-.987-2.553a1.5,1.5,0,0,0-.747-.176,1.548,1.548,0,0,0-.79.2,2.17,2.17,0,0,0-.642.555,3.665,3.665,0,0,0-.49.813,7.229,7.229,0,0,0-.571,2.937Q187.6,290.228,188.589,290.783Z",
  transform: "translate(-179.072 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.313,291.91a.805.805,0,0,1-.918-.9,13.136,13.136,0,0,1,.187-1.85l.253-1.582a16.372,16.372,0,0,0,.255-2.187,3.91,3.91,0,0,0-.063-.834.859.859,0,0,0-.176-.355.637.637,0,0,0-.5-.176,1.513,1.513,0,0,0-.653.147,3.261,3.261,0,0,0-.653.4,6.164,6.164,0,0,0-1.242,1.342q-.071.841-.24,1.95l-.492,3.892h-1.521l.434-3.416.116-.732a16.687,16.687,0,0,0,.2-2.113,5.16,5.16,0,0,0-.055-.947.864.864,0,0,0-.161-.363.7.7,0,0,0-.539-.176,1.811,1.811,0,0,0-.721.147,3.276,3.276,0,0,0-.692.408,6.423,6.423,0,0,0-1.319,1.371l-.784,5.821h-1.505l1-7.424-.763-.455.14-.687,1.866-.4.371.184-.147,1.634a5,5,0,0,1,2.29-1.671,2.509,2.509,0,0,1,.821-.147,2.223,2.223,0,0,1,.695.1,1.3,1.3,0,0,1,.511.324,2.35,2.35,0,0,1,.518,1.482,4.949,4.949,0,0,1,2.205-1.758,2.462,2.462,0,0,1,.821-.147,1.929,1.929,0,0,1,.726.132,1.4,1.4,0,0,1,.55.416,2.741,2.741,0,0,1,.492,1.782,9.131,9.131,0,0,1-.155,1.5q-.47,2.878-.5,3.424a3.322,3.322,0,0,0-.005.7c.021.105.066.155.139.155a1.562,1.562,0,0,0,.84-.508l.239.4a2.726,2.726,0,0,1-1.866,1.118Z",
  transform: "translate(-173.332 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.21,294.243q-.959,0-.958-.879a17.235,17.235,0,0,1,.255-2.113l.719-4.719-1.142-.392.139-.624,2.327-.395.379.184-1.071,7.34a1.673,1.673,0,0,0-.024.255c0,.221.063.332.192.332.19,0,.466-.171.826-.516l.245.408a2.722,2.722,0,0,1-1.224.979A1.639,1.639,0,0,1,196.21,294.243Zm1.14-10.856a.9.9,0,0,1-.368-.076.82.82,0,0,1-.534-.811,1.07,1.07,0,0,1,.379-.811,1.012,1.012,0,0,1,.655-.332,1.323,1.323,0,0,1,.479.071.789.789,0,0,1,.54.779,1.169,1.169,0,0,1-.363.84A1.094,1.094,0,0,1,197.35,283.387Z",
  transform: "translate(-164.261 -281.358)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.93,291.918q-1,0-.947-1.018c.021-.334.058-.679.116-1.032l.145-.866c.026-.174.087-.518.182-1.029s.163-.905.205-1.182a10.2,10.2,0,0,0,.161-1.5,3.194,3.194,0,0,0-.061-.742.867.867,0,0,0-.176-.363.716.716,0,0,0-.547-.176,1.831,1.831,0,0,0-.729.147,3.2,3.2,0,0,0-.69.408,6.3,6.3,0,0,0-1.318,1.371l-.787,5.821h-1.505l1-7.424-.755-.455.139-.687,1.866-.4.371.184-.155,1.634a5,5,0,0,1,2.29-1.671,2.578,2.578,0,0,1,.839-.147,2.138,2.138,0,0,1,.74.118,1.326,1.326,0,0,1,.55.4,2.84,2.84,0,0,1,.469,1.813,8.324,8.324,0,0,1-.168,1.534q-.17.884-.255,1.342a11.072,11.072,0,0,0-.292,2.761.181.181,0,0,0,.2.153,1.366,1.366,0,0,0,.611-.355l.237.4a2.369,2.369,0,0,1-1.116.84A1.6,1.6,0,0,1,202.93,291.918Z",
  transform: "translate(-161.172 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M204.065,283.059a3.955,3.955,0,0,1,1.487-.271,4.635,4.635,0,0,1,1.658.324l.926-.324-1.49,9.561A3.523,3.523,0,0,1,205,294.923a4.527,4.527,0,0,1-2.5.75,4.58,4.58,0,0,1-1.69-.271l.387-1.426a4.741,4.741,0,0,0,2.058.479,2.051,2.051,0,0,0,1.326-.311,2.239,2.239,0,0,0,.487-1.271l.345-2.142a3.3,3.3,0,0,1-1.619,1.079,3.1,3.1,0,0,1-.853.1,2.089,2.089,0,0,1-.99-.253,2.246,2.246,0,0,1-.795-.687,4.069,4.069,0,0,1-.624-2.392,6.189,6.189,0,0,1,.595-2.558A5.3,5.3,0,0,1,204.065,283.059Zm2.337.987a1.6,1.6,0,0,0-1.026-.316,2.442,2.442,0,0,0-1.074.216,2.746,2.746,0,0,0-.808.595,3.814,3.814,0,0,0-.611.855,5.576,5.576,0,0,0-.429,1.008,6.878,6.878,0,0,0-.332,2.116,3.547,3.547,0,0,0,.329,1.687.986.986,0,0,0,.887.608,2.648,2.648,0,0,0,1.866-.911,3.912,3.912,0,0,0,.418-.479Z",
  transform: "translate(-155.356 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.558,290.291a3.638,3.638,0,0,0,1.4.524,3.534,3.534,0,0,0,.611.053,5.542,5.542,0,0,0,.568-.029,1.524,1.524,0,0,0,.5-.147.948.948,0,0,0,.516-.934,1.949,1.949,0,0,0-.855-1.487c-.166-.134-.324-.258-.474-.368a5,5,0,0,1-.505-.416,4.373,4.373,0,0,1-.534-.579,2.57,2.57,0,0,1-.6-1.5,2.484,2.484,0,0,1,.242-1.158,2.449,2.449,0,0,1,.653-.787,3.257,3.257,0,0,1,2.074-.671,6.258,6.258,0,0,1,1.395.118,3.97,3.97,0,0,1,.579.168l-.292,1.287a1.886,1.886,0,0,0-1.082-.5,2.589,2.589,0,0,0-.613-.076,2.791,2.791,0,0,0-.542.047,1.273,1.273,0,0,0-.44.168,1.087,1.087,0,0,0-.516,1c0,.566.408,1.158,1.224,1.782a6.477,6.477,0,0,1,1.1,1.011,2.545,2.545,0,0,1,.626,1.534,2.461,2.461,0,0,1-.253,1.19,2.275,2.275,0,0,1-.674.768,3.493,3.493,0,0,1-2.126.624,5.716,5.716,0,0,1-1.929-.284,1.175,1.175,0,0,1-.339-.171Z",
  transform: "translate(-147.625 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.745,291.67q-1.757-.746-1.758-3.44a6.149,6.149,0,0,1,1.195-3.7,4.237,4.237,0,0,1,1.953-1.519,3.45,3.45,0,0,1,1.266-.224,3.168,3.168,0,0,1,1.255.24,2.589,2.589,0,0,1,.955.695,4.023,4.023,0,0,1,.808,2.69,6.15,6.15,0,0,1-1.195,3.755,4.389,4.389,0,0,1-1.958,1.526,3.576,3.576,0,0,1-1.269.216A3.155,3.155,0,0,1,209.745,291.67Zm.826-.887a1.452,1.452,0,0,0,.747.187,1.558,1.558,0,0,0,.789-.208,2.233,2.233,0,0,0,.642-.555,3.739,3.739,0,0,0,.487-.81,7.229,7.229,0,0,0,.571-2.937q0-1.99-.987-2.553a1.5,1.5,0,0,0-.747-.176,1.555,1.555,0,0,0-.79.2,2.17,2.17,0,0,0-.642.555,3.77,3.77,0,0,0-.49.813,7.272,7.272,0,0,0-.568,2.937Q209.584,290.228,210.571,290.783Z",
  transform: "translate(-143.206 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M213.123,291.67q-1.757-.746-1.758-3.44a6.148,6.148,0,0,1,1.195-3.7,4.23,4.23,0,0,1,1.95-1.519,3.474,3.474,0,0,1,1.269-.224,3.168,3.168,0,0,1,1.255.24,2.589,2.589,0,0,1,.955.695,4.023,4.023,0,0,1,.808,2.69,6.15,6.15,0,0,1-1.195,3.755,4.389,4.389,0,0,1-1.958,1.526,3.576,3.576,0,0,1-1.268.216A3.155,3.155,0,0,1,213.123,291.67Zm.826-.887a1.445,1.445,0,0,0,.747.187,1.558,1.558,0,0,0,.79-.208,2.268,2.268,0,0,0,.642-.555,3.741,3.741,0,0,0,.487-.81,7.23,7.23,0,0,0,.571-2.937q0-1.99-.987-2.553a1.5,1.5,0,0,0-.747-.176,1.554,1.554,0,0,0-.789.2,2.171,2.171,0,0,0-.642.555,3.767,3.767,0,0,0-.489.813,7.272,7.272,0,0,0-.568,2.937Q212.962,290.228,213.949,290.783Z",
  transform: "translate(-137.694 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.835,291.918c-.666,0-.984-.339-.947-1.018.021-.334.061-.679.116-1.032l.147-.866c.024-.174.084-.518.179-1.029s.166-.905.205-1.182a10.291,10.291,0,0,0,.163-1.5,3.163,3.163,0,0,0-.063-.742.838.838,0,0,0-.176-.363.712.712,0,0,0-.547-.176,1.809,1.809,0,0,0-.726.147,3.276,3.276,0,0,0-.692.408,6.3,6.3,0,0,0-1.318,1.371l-.787,5.821h-1.5l1-7.424-.758-.455.14-.687,1.866-.4.371.184-.155,1.634a5,5,0,0,1,2.29-1.671,2.582,2.582,0,0,1,.842-.147,2.133,2.133,0,0,1,.737.118,1.327,1.327,0,0,1,.55.4,2.84,2.84,0,0,1,.471,1.813,8.351,8.351,0,0,1-.171,1.534q-.17.884-.253,1.342a11,11,0,0,0-.295,2.761.181.181,0,0,0,.2.153,1.366,1.366,0,0,0,.611-.355l.24.4a2.378,2.378,0,0,1-1.119.84A1.591,1.591,0,0,1,220.835,291.918Z",
  transform: "translate(-131.95 -279.025)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.941,287.492a.735.735,0,0,1-.284-.187.634.634,0,0,1-.158-.271,1.341,1.341,0,0,1-.042-.374,1.017,1.017,0,0,1,.132-.474,1.459,1.459,0,0,1,.3-.4,1.113,1.113,0,0,1,.718-.324,1.573,1.573,0,0,1,.547.076.735.735,0,0,1,.461.747,1.207,1.207,0,0,1-.461.966,1.135,1.135,0,0,1-.711.308A1.4,1.4,0,0,1,218.941,287.492Z",
  transform: "translate(-126.121 -274.66)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M220.512,287.492a.756.756,0,0,1-.284-.187.662.662,0,0,1-.158-.271,1.339,1.339,0,0,1-.042-.374,1.017,1.017,0,0,1,.132-.474,1.459,1.459,0,0,1,.3-.4,1.114,1.114,0,0,1,.721-.324,1.557,1.557,0,0,1,.545.076.736.736,0,0,1,.463.747,1.21,1.21,0,0,1-.463.966,1.135,1.135,0,0,1-.711.308A1.4,1.4,0,0,1,220.512,287.492Z",
  transform: "translate(-123.558 -274.66)",
  fill: "#542493"
}), /*#__PURE__*/React.createElement("path", {
  d: "M222.081,287.492a.725.725,0,0,1-.282-.187.641.641,0,0,1-.161-.271,1.353,1.353,0,0,1-.039-.374,1.012,1.012,0,0,1,.129-.474,1.522,1.522,0,0,1,.3-.4,1.1,1.1,0,0,1,.718-.324,1.557,1.557,0,0,1,.545.076.736.736,0,0,1,.463.747,1.21,1.21,0,0,1-.463.966,1.128,1.128,0,0,1-.708.308A1.413,1.413,0,0,1,222.081,287.492Z",
  transform: "translate(-120.994 -274.66)",
  fill: "#542493"
})));

var _ref9 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(960 854)",
  fill: "#3c3856",
  fontSize: 24,
  fontFamily: "Montserrat-Medium, Montserrat",
  fontWeight: 500,
  letterSpacing: "0.03em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: -623.664,
  y: 0
}, "Our website is currently undergoing scheduled maintenance, will be right back in a few mintues."), /*#__PURE__*/React.createElement("tspan", {
  x: -182.724,
  y: 47
}, "Thank you for your patience."));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M835.89,351.257h-633.2l47.088-20.47H788.8Z",
  transform: "translate(0 208.344)",
  fill: "url(#b)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M452.459,356.594H314.424L327.69,306.61h111.5Z",
  transform: "translate(-171.407 -4.382)",
  fill: "url(#c)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M505.346,336.627H300.333l6.061-13.882H499.285Z",
  transform: "translate(-190.805 17.83)",
  fill: "url(#e)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M666.313,489.09H265.436a11.208,11.208,0,0,1-11.189-11.206L255,190.648a11.283,11.283,0,0,1,11.251-11.206H667.126a11.208,11.208,0,0,1,11.189,11.206l-.753,287.237A11.281,11.281,0,0,1,666.313,489.09Z",
  transform: "translate(-254.247 -179.442)",
  fill: "#4e5683"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M666.443,343.636H265.569a11.208,11.208,0,0,1-11.189-11.206L254.5,285.1H677.818l-.124,47.328A11.281,11.281,0,0,1,666.443,343.636Z",
  transform: "translate(-254.064 -33.988)",
  fill: "url(#f)"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.8 14.715)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#h)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M260.474,408.453l.585-222.819H654.943l-.585,222.819Z",
  transform: "translate(-260.474 -185.633)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-70.66 182.982)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M383.789,306.417H230.743c-.019-4.653,1.676-9.87,5.692-15.662a30.606,30.606,0,0,1,24.042-12.943c14.8-.345,30.159,10,43.49,3.558,5.694-2.752,9.613-8.08,14.241-12.389s11.125-7.833,17.088-5.728c7.608,2.688,10.281,14.143,17.3,18.126,5.8,3.292,17.2-2.745,28.239,3.142C387.761,288.215,390.7,299.109,383.789,306.417Z",
  transform: "translate(-230.743 -262.626)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M263.779,306.442a12.663,12.663,0,0,0,4.245,1.383H441.164c.017-4.318-1.557-9.164-5.286-14.542a28.43,28.43,0,0,0-22.321-12.016c-13.742-.319-28,9.283-40.381,3.3-5.286-2.555-8.924-7.5-13.221-11.5s-10.331-7.272-15.866-5.316c-7.063,2.5-9.271,11.874-15.785,15.572-5.385,3.059-12.171,1.416-17.91-.908s-11.586-5.326-17.753-4.763a16.364,16.364,0,0,0-13.92,11.66C277.017,295.519,258.565,302.663,263.779,306.442Z",
  transform: "translate(-186.539 -256.374)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46.85 1.855)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M546.714,301.122s-11.146-19.517-12.964-21.53c-11.467-12.693-26.68-12.834-42.163-9.628-4.482.929-16.344,7.161-20.648,6.3-3.353-.67-7.377-13.411-18.107-12.741s-11.377,13.411-11.377,13.411-6.731-14.8-17.461-13.437-10.73,11.36-2.683,18.77c0,0-17.1-5.131-33.7,2.816s-8.67,18.369-8.67,18.369Z",
  transform: "translate(-76.189 -263.407)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M621.374,295.052H324.108s32.191-14.084,59.855-13.076,56.335,2.412,85.508-.052,43.76-15.541,80.479-9.506S586.668,285.5,597.23,285.5,621.374,295.052,621.374,295.052Z",
  transform: "translate(-149.066 -253.17)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.43,290.489H250.456s18.611-12.137,40.742-12.1,19.115,5.15,41.75,3.17,26.155-11.184,51.3-5.651C401.53,279.7,414.43,290.489,414.43,290.489Z",
  transform: "translate(-250.456 -248.607)",
  fill: "#3c3856"
})), /*#__PURE__*/React.createElement("path", {
  d: "M294.484,276.577c-4.169-4.506-10.54-8.368-16.192-5.97-4.164,1.768-6.45,6.384-10.388,8.61-5.968,3.38-13.418.345-20.256.856-7.61.568-16.9,16.111-16.9,16.111h93.686s-10.856-4.993-17.019-7.472C301.871,286.481,298.387,280.791,294.484,276.577Z",
  transform: "translate(-230.739 -252.65)",
  fill: "#3c3856"
}), /*#__PURE__*/React.createElement("path", {
  d: "M422.847,300.044H323.562c-.012-3.018,1.086-6.4,3.693-10.16a19.857,19.857,0,0,1,15.6-8.4c9.6-.223,19.567,6.486,28.213,2.308,3.7-1.785,6.236-5.24,9.238-8.038s7.218-5.081,11.087-3.715c4.936,1.744,6.671,9.174,11.222,11.759,3.762,2.137,11.156-1.78,18.321,2.039A9.144,9.144,0,0,1,422.847,300.044Z",
  transform: "translate(-102.967 -250.223)",
  fill: "#3c3856"
}))));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M630.825,346.661l-364.781-.012L305.3,320.525H591.6l39.252,26.124C630.863,346.656,630.851,346.661,630.825,346.661Z",
  transform: "translate(-266.044 -320.525)",
  fill: "url(#i)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M630.825,331.529l-364.781-.012v10.9H630.825l.029-10.9C630.863,331.524,630.851,331.529,630.825,331.529Z",
  transform: "translate(-266.044 -305.393)",
  fill: "url(#j)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M298.381,323.51H286.353c-.777,0-1.084-.238-.685-.53l1.317-.958a4.246,4.246,0,0,1,2.084-.513h11.786c.763,0,1.1.231.753.513l-1.172.958A3.892,3.892,0,0,1,298.381,323.51Z",
  transform: "translate(-259.311 -321.509)",
  fill: "url(#l)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M306.558,323.51H294.532c-.78,0-1.131-.238-.787-.53l1.129-.958a3.692,3.692,0,0,1,1.984-.513l11.786,0c.763,0,1.146.228.853.511l-.986.958A3.359,3.359,0,0,1,306.558,323.51Z",
  transform: "translate(-248.133 -321.509)",
  fill: "url(#l)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M314.74,323.51H302.712c-.777,0-1.174-.238-.889-.53l.944-.958a3.183,3.183,0,0,1,1.885-.513h11.786c.763,0,1.191.231.953.513l-.8.958A2.882,2.882,0,0,1,314.74,323.51Z",
  transform: "translate(-236.958 -321.509)",
  fill: "url(#l)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M322.925,323.51H310.9c-.78,0-1.222-.238-.993-.53l.758-.958a2.729,2.729,0,0,1,1.785-.513h11.786c.763,0,1.233.231,1.053.513l-.613.958A2.462,2.462,0,0,1,322.925,323.51Z",
  transform: "translate(-225.787 -321.509)",
  fill: "url(#l)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M331.114,323.51H319.087c-.777,0-1.267-.238-1.093-.53l.57-.958a2.321,2.321,0,0,1,1.685-.513h11.786c.763,0,1.279.231,1.153.513l-.428.958C332.628,323.272,331.892,323.508,331.114,323.51Z",
  transform: "translate(-214.62 -321.509)",
  fill: "url(#l)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M339.307,323.508l-12.026,0c-.779,0-1.314-.238-1.2-.53l.385-.958c.114-.283.822-.513,1.585-.513h11.786c.763,0,1.324.231,1.253.513l-.242.958C340.775,323.272,340.086,323.508,339.307,323.508Z",
  transform: "translate(-203.457 -321.509)",
  fill: "url(#l)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M347.505,323.51H335.477c-.777,0-1.359-.238-1.3-.53l.2-.958c.057-.283.722-.513,1.485-.513h11.786c.763,0,1.369.231,1.352.513l-.055.958C348.929,323.272,348.283,323.51,347.505,323.51Z",
  transform: "translate(-192.298 -321.509)",
  fill: "url(#l)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M355.7,323.508l-12.026,0c-.78,0-1.407-.238-1.4-.53l.012-.958c0-.283.625-.511,1.386-.511l11.786,0c.763,0,1.414.231,1.452.513l.131.958C357.083,323.272,356.484,323.508,355.7,323.508Z",
  transform: "translate(-181.142 -321.509)",
  fill: "url(#l)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M364.013,323.51H351.985c-.777,0-1.452-.238-1.5-.53l-.173-.958c-.052-.283.525-.513,1.288-.513h11.783c.763,0,1.457.231,1.552.513l.316.958C365.344,323.272,364.79,323.51,364.013,323.51Z",
  transform: "translate(-170.093 -321.509)",
  fill: "url(#l)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M372.329,323.51H360.3c-.78,0-1.5-.238-1.609-.53l-.359-.958c-.107-.283.425-.513,1.188-.513h11.783c.763,0,1.5.231,1.652.513l.5.958C373.615,323.272,373.109,323.51,372.329,323.51Z",
  transform: "translate(-159.054 -321.509)",
  fill: "url(#l)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M380.653,323.51l-12.028,0a2.309,2.309,0,0,1-1.709-.528l-.547-.958c-.164-.283.326-.511,1.088-.511l11.783,0a2.586,2.586,0,0,1,1.752.513l.689.958C381.891,323.272,381.43,323.51,380.653,323.51Z",
  transform: "translate(-148.02 -321.509)",
  fill: "url(#l)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M388.977,323.51l-12.026,0a2.726,2.726,0,0,1-1.813-.528l-.732-.958c-.219-.283.226-.513.989-.513H387.18a3.016,3.016,0,0,1,1.849.513l.875.958C390.17,323.272,389.757,323.51,388.977,323.51Z",
  transform: "translate(-136.99 -321.509)",
  fill: "url(#l)"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M401.738,323.508l-16.456,0a3.19,3.19,0,0,1-1.918-.53l-.92-.958c-.271-.283.128-.511.891-.511l16.125,0a3.6,3.6,0,0,1,1.973.511l1.105.958C402.875,323.27,402.518,323.508,401.738,323.508Z",
  transform: "translate(-125.963 -321.509)",
  fill: "url(#x)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M412.084,323.51l-16.563,0a3.811,3.811,0,0,1-2.041-.53l-1.148-.958c-.34-.283,0-.513.768-.511l16.23,0a4.3,4.3,0,0,1,2.094.511l1.336.96C413.163,323.272,412.863,323.51,412.084,323.51Z",
  transform: "translate(-112.417 -321.509)",
  fill: "url(#x)"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M289.764,333.5H275.418c-.929,0-1.219-.337-.651-.749l5.293-3.857a5.1,5.1,0,0,1,2.56-.694h13.706c.886,0,1.226.309.758.694l-4.72,3.857A4.83,4.83,0,0,1,289.764,333.5Z",
  transform: "translate(-274.477 -312.291)",
  fill: "url(#z)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M299.523,333.5H285.176c-.929,0-1.283-.337-.8-.749l4.544-3.857a4.388,4.388,0,0,1,2.424-.694h13.706c.887,0,1.288.309.891.694l-3.969,3.857A4.121,4.121,0,0,1,299.523,333.5Z",
  transform: "translate(-261.145 -312.291)",
  fill: "url(#z)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M309.285,333.5H294.94c-.929,0-1.35-.337-.943-.749l3.8-3.857a3.743,3.743,0,0,1,2.289-.694h13.706c.886,0,1.348.309,1.027.694l-3.22,3.857A3.483,3.483,0,0,1,309.285,333.5Z",
  transform: "translate(-247.819 -312.291)",
  fill: "url(#z)"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M319.053,333.5H304.708c-.929,0-1.414-.337-1.089-.749l3.047-3.857a3.166,3.166,0,0,1,2.153-.694h13.706c.887,0,1.407.309,1.162.694l-2.472,3.857A2.924,2.924,0,0,1,319.053,333.5Z",
  transform: "translate(-234.498 -312.291)",
  fill: "url(#z)"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M397.523,333.5H315.159c-1.274,0-2.16-.245-1.982-.547l2.531-4.249a4.26,4.26,0,0,1,2.5-.5H396.9c1.217,0,2.234.226,2.272.5l.58,4.249C399.8,333.26,398.8,333.5,397.523,333.5Z",
  transform: "translate(-221.233 -312.291)",
  fill: "url(#z)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M368.406,333.5H354.058c-.927,0-1.742-.337-1.816-.749l-.7-3.857c-.069-.385.594-.694,1.481-.694h13.706c.886,0,1.709.309,1.837.694l1.276,3.857C369.974,333.167,369.335,333.5,368.406,333.5Z",
  transform: "translate(-168.399 -312.291)",
  fill: "url(#z)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M378.648,333.5H364.3c-.929,0-1.809-.337-1.963-.749l-1.452-3.857c-.145-.385.459-.694,1.345-.694h13.706a2.488,2.488,0,0,1,1.97.694l2.027,3.857C380.152,333.167,379.577,333.5,378.648,333.5Z",
  transform: "translate(-155.553 -312.291)",
  fill: "url(#z)"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M388.9,333.5H374.551a2.738,2.738,0,0,1-2.108-.749l-2.2-3.857c-.219-.385.323-.694,1.21-.694h13.706a2.976,2.976,0,0,1,2.106.694l2.776,3.857C390.336,333.167,389.825,333.5,388.9,333.5Z",
  transform: "translate(-142.712 -312.291)",
  fill: "url(#z)"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M411.437,331.649H395.322a4.022,4.022,0,0,1-2.431-.749l-.611-.613c-.406-.406.007-.734.917-.734H409.03a4.476,4.476,0,0,1,2.5.734l.713.613C412.725,331.312,412.367,331.649,411.437,331.649Z",
  transform: "translate(-112.524 -310.436)",
  fill: "url(#ah)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M422.332,331.649H406.217a4.783,4.783,0,0,1-2.59-.749l-.744-.613c-.492-.406-.15-.734.763-.734h15.831a5.307,5.307,0,0,1,2.662.734l.841.613C423.549,331.312,423.262,331.649,422.332,331.649Z",
  transform: "translate(-98.022 -310.436)",
  fill: "url(#ah)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M400.549,331.649H384.433a3.322,3.322,0,0,1-2.27-.751l-.48-.611c-.321-.406.162-.734,1.074-.734h15.831a3.754,3.754,0,0,1,2.348.734l.582.613C401.911,331.312,401.478,331.649,400.549,331.649Z",
  transform: "translate(-127.032 -310.436)",
  fill: "url(#ah)"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M409.495,330.187H393.83a3.878,3.878,0,0,1-2.343-.711l-.58-.577c-.383-.385.026-.694.915-.694h15.4a4.327,4.327,0,0,1,2.412.694l.673.577C410.757,329.866,410.4,330.187,409.495,330.187Z",
  transform: "translate(-114.395 -312.291)",
  fill: "url(#ak)"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M296.611,325.812h-12.5c-.81,0-1.115-.254-.682-.57l2.745-2a4.363,4.363,0,0,1,2.165-.542h12.128c.784,0,1.124.24.756.542l-2.446,2A4.065,4.065,0,0,1,296.611,325.812Z",
  transform: "translate(-262.425 -319.868)",
  fill: "url(#al)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M305.116,325.813h-12.5c-.81,0-1.164-.257-.794-.57l2.358-2a3.787,3.787,0,0,1,2.06-.544l12.126,0c.784,0,1.172.24.863.542l-2.058,2A3.5,3.5,0,0,1,305.116,325.813Z",
  transform: "translate(-250.805 -319.869)",
  fill: "url(#am)"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M313.623,325.813h-12.5c-.81,0-1.214-.254-.906-.57l1.968-2a3.277,3.277,0,0,1,1.956-.542l12.128,0c.784,0,1.219.242.967.544l-1.671,2A2.989,2.989,0,0,1,313.623,325.813Z",
  transform: "translate(-239.189 -319.869)",
  fill: "url(#am)"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M322.13,325.813h-12.5c-.81,0-1.264-.257-1.015-.57l1.578-2a2.8,2.8,0,0,1,1.851-.544H324.17c.784,0,1.267.242,1.074.544l-1.281,2A2.548,2.548,0,0,1,322.13,325.813Z",
  transform: "translate(-227.576 -319.869)",
  fill: "url(#am)"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M330.648,325.812h-12.5c-.81,0-1.314-.254-1.127-.57l1.191-2a2.366,2.366,0,0,1,1.744-.542h12.128c.784,0,1.312.24,1.179.542l-.894,2C332.226,325.558,331.456,325.812,330.648,325.812Z",
  transform: "translate(-215.968 -319.868)",
  fill: "url(#al)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M339.167,325.813h-12.5c-.81,0-1.364-.254-1.238-.57l.8-2c.121-.3.853-.542,1.64-.542l12.126,0c.784,0,1.359.242,1.286.544l-.506,2C340.695,325.559,339.975,325.813,339.167,325.813Z",
  transform: "translate(-204.365 -319.869)",
  fill: "url(#am)"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M347.69,325.813h-12.5c-.81,0-1.412-.254-1.348-.57l.414-2c.062-.3.749-.544,1.533-.544l12.128,0c.784,0,1.407.24,1.388.542l-.114,2C349.168,325.559,348.5,325.813,347.69,325.813Z",
  transform: "translate(-192.765 -319.869)",
  fill: "url(#am)"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M356.219,325.812h-12.5c-.81,0-1.462-.257-1.459-.57l.026-2c0-.3.642-.542,1.426-.542h12.128c.784,0,1.454.24,1.495.542l.273,2C357.647,325.555,357.027,325.812,356.219,325.812Z",
  transform: "translate(-181.171 -319.868)",
  fill: "url(#as)"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M364.961,325.812h-12.5c-.81,0-1.512-.257-1.569-.57l-.364-2c-.055-.3.537-.542,1.321-.542h12.128c.784,0,1.5.24,1.6.542l.663,2C366.34,325.558,365.77,325.812,364.961,325.812Z",
  transform: "translate(-169.791 -319.868)",
  fill: "url(#al)"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M373.725,325.812h-12.5c-.81,0-1.561-.254-1.68-.57l-.753-2c-.112-.3.433-.542,1.217-.542h12.128c.784,0,1.55.24,1.706.542l1.05,2C375.054,325.555,374.533,325.812,373.725,325.812Z",
  transform: "translate(-158.433 -319.868)",
  fill: "url(#al)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M382.492,325.812h-12.5a2.4,2.4,0,0,1-1.792-.57l-1.141-2c-.171-.3.328-.542,1.112-.542H380.3a2.639,2.639,0,0,1,1.811.542l1.438,2C383.771,325.558,383.3,325.812,382.492,325.812Z",
  transform: "translate(-147.077 -319.868)",
  fill: "url(#al)"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M391.264,325.813h-12.5a2.823,2.823,0,0,1-1.9-.57l-1.531-2c-.231-.3.221-.544,1.005-.544l12.128,0a3.1,3.1,0,0,1,1.918.542l1.828,2C392.5,325.559,392.072,325.813,391.264,325.813Z",
  transform: "translate(-135.726 -319.869)",
  fill: "url(#am)"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M404.645,325.811l-17.109,0a3.318,3.318,0,0,1-2.013-.57l-1.918-2c-.288-.3.117-.542.9-.542l16.6,0a3.722,3.722,0,0,1,2.046.542l2.3,2C405.814,325.554,405.453,325.811,404.645,325.811Z",
  transform: "translate(-124.378 -319.869)",
  fill: "url(#ax)"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M415.543,325.813l-17.219,0a4,4,0,0,1-2.148-.57l-2.4-2c-.361-.3-.014-.542.77-.542l16.7,0a4.426,4.426,0,0,1,2.177.542l2.785,2C416.651,325.559,416.352,325.813,415.543,325.813Z",
  transform: "translate(-110.439 -319.869)",
  fill: "url(#al)"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M304.4,327.764l-22.091,0c-1.155,0-1.816-.2-1.473-.452l3.42-2.493a6.285,6.285,0,0,1,2.614-.425l21.4,0c1.122,0,1.813.19,1.547.425L307,327.312A5.645,5.645,0,0,1,304.4,327.764Z",
  transform: "translate(-265.853 -317.544)",
  fill: "url(#az)"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M317.795,327.759l-22.1,0c-1.155,0-1.873-.2-1.607-.452l2.69-2.493a5.376,5.376,0,0,1,2.488-.425l21.409,0c1.119,0,1.868.19,1.671.425l-2.082,2.493A4.783,4.783,0,0,1,317.795,327.759Z",
  transform: "translate(-247.556 -317.544)",
  fill: "url(#ba)"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M321.271,327.759H308.252c-.841,0-1.3-.278-1.036-.618l1.709-2.165a2.915,2.915,0,0,1,1.942-.587h12.613c.815,0,1.31.261,1.1.587l-1.386,2.165A2.656,2.656,0,0,1,321.271,327.759Z",
  transform: "translate(-229.512 -317.544)",
  fill: "url(#bb)"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M330.138,327.759H317.121c-.844,0-1.362-.278-1.157-.618l1.288-2.165a2.46,2.46,0,0,1,1.828-.587h12.61c.818,0,1.362.261,1.217.587l-.967,2.165C331.787,327.481,330.982,327.759,330.138,327.759Z",
  transform: "translate(-217.427 -317.544)",
  fill: "url(#bb)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M339.01,327.759H325.993c-.844,0-1.414-.278-1.279-.618l.867-2.165c.131-.326.9-.587,1.714-.587h12.613c.815,0,1.412.261,1.329.587l-.544,2.165C340.607,327.481,339.853,327.759,339.01,327.759Z",
  transform: "translate(-205.346 -317.544)",
  fill: "url(#bb)"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M347.886,327.759H334.87c-.844,0-1.469-.278-1.4-.618l.447-2.165c.066-.326.782-.587,1.6-.587h12.61c.818,0,1.464.261,1.445.587l-.126,2.165C349.429,327.481,348.73,327.759,347.886,327.759Z",
  transform: "translate(-193.271 -317.544)",
  fill: "url(#be)"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M356.772,327.759H343.753c-.844,0-1.523-.278-1.519-.618l.028-2.165c0-.326.668-.587,1.483-.587h12.613c.815,0,1.514.261,1.557.587l.3,2.165C358.259,327.481,357.613,327.759,356.772,327.759Z",
  transform: "translate(-181.202 -317.544)",
  fill: "url(#be)"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M365.887,327.759H352.868c-.841,0-1.576-.278-1.637-.618l-.394-2.165c-.059-.326.556-.587,1.371-.587h12.61c.818,0,1.566.261,1.673.587l.718,2.165C367.32,327.481,366.729,327.759,365.887,327.759Z",
  transform: "translate(-169.365 -317.544)",
  fill: "url(#bb)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M375.023,327.759H362c-.841,0-1.63-.278-1.759-.618l-.813-2.165c-.124-.326.44-.587,1.257-.587H373.3a2.319,2.319,0,0,1,1.787.587l1.136,2.165C376.4,327.481,375.865,327.759,375.023,327.759Z",
  transform: "translate(-157.549 -317.544)",
  fill: "url(#bb)"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M384.165,327.759H371.146a2.494,2.494,0,0,1-1.878-.618l-1.236-2.165c-.185-.326.328-.587,1.143-.587h12.61a2.742,2.742,0,0,1,1.9.587l1.559,2.165C385.491,327.481,385.009,327.759,384.165,327.759Z",
  transform: "translate(-145.739 -317.544)",
  fill: "url(#bb)"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M393.311,327.759H380.292a2.961,2.961,0,0,1-2-.618l-1.654-2.165c-.25-.326.211-.587,1.029-.587h12.61a3.232,3.232,0,0,1,2.015.587l1.977,2.165C394.583,327.481,394.155,327.759,393.311,327.759Z",
  transform: "translate(-133.932 -317.544)",
  fill: "url(#be)"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M402.257,327.755H389.24a3.444,3.444,0,0,1-2.115-.62l-2.068-2.165c-.311-.323.1-.585.917-.585h12.61a3.75,3.75,0,0,1,2.125.587l2.391,2.163C403.476,327.477,403.1,327.755,402.257,327.755Z",
  transform: "translate(-122.394 -317.55)",
  fill: "url(#bk)"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M420.905,327.765l-21.758-.01a5.775,5.775,0,0,1-2.612-.452l-2.871-2.493c-.273-.235.416-.425,1.535-.425l21.078.01a6.333,6.333,0,0,1,2.621.425l3.472,2.493C422.716,327.562,422.063,327.765,420.905,327.765Z",
  transform: "translate(-110.484 -317.55)",
  fill: "url(#bl)"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M314.472,329.879H279.039c-.877,0-1.176-.3-.668-.673l3.23-2.353a4.848,4.848,0,0,1,2.415-.637h34.278c.848,0,1.245.285.884.637l-2.422,2.353A3.853,3.853,0,0,1,314.472,329.879Z",
  transform: "translate(-269.456 -315.028)",
  fill: "url(#bm)"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M311.092,329.879H297.515c-.879,0-1.293-.3-.929-.673l2.315-2.353a3.58,3.58,0,0,1,2.165-.637H314.2c.848,0,1.3.285,1.005.637l-1.963,2.353A3.272,3.272,0,0,1,311.092,329.879Z",
  transform: "translate(-244.223 -315.028)",
  fill: "url(#bm)"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M320.337,329.879H306.759c-.879,0-1.352-.3-1.06-.673l1.859-2.353a3.038,3.038,0,0,1,2.042-.637h13.135c.851,0,1.357.285,1.131.637l-1.507,2.353A2.76,2.76,0,0,1,320.337,329.879Z",
  transform: "translate(-231.615 -315.028)",
  fill: "url(#bm)"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M329.588,329.879h-13.58c-.877,0-1.409-.3-1.191-.673l1.4-2.353a2.56,2.56,0,0,1,1.918-.637h13.136c.851,0,1.414.285,1.255.637l-1.048,2.353C331.313,329.578,330.467,329.879,329.588,329.879Z",
  transform: "translate(-219.011 -315.028)",
  fill: "url(#bm)"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M338.842,329.879H325.265c-.879,0-1.471-.3-1.321-.673l.944-2.353c.14-.352.943-.637,1.794-.637h13.136c.851,0,1.469.285,1.378.637l-.592,2.353C340.511,329.578,339.722,329.879,338.842,329.879Z",
  transform: "translate(-206.412 -315.028)",
  fill: "url(#bm)"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M348.1,329.879H334.526c-.879,0-1.528-.3-1.452-.673l.487-2.353c.071-.352.82-.637,1.671-.637h13.135c.851,0,1.523.285,1.5.637l-.135,2.353C349.712,329.578,348.983,329.879,348.1,329.879Z",
  transform: "translate(-193.82 -315.028)",
  fill: "url(#bm)"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M357.373,329.879h-13.58c-.877,0-1.588-.3-1.583-.673l.031-2.353c0-.352.7-.637,1.547-.637h13.136c.851,0,1.578.285,1.626.637l.321,2.353C358.922,329.578,358.25,329.879,357.373,329.879Z",
  transform: "translate(-181.235 -315.028)",
  fill: "url(#bm)"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M366.894,329.879H353.316c-.879,0-1.647-.3-1.713-.673l-.43-2.353c-.064-.352.575-.637,1.424-.637h13.138c.848,0,1.633.285,1.749.637l.78,2.353C368.384,329.578,367.773,329.879,366.894,329.879Z",
  transform: "translate(-168.903 -315.028)",
  fill: "url(#bm)"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M376.437,329.879H362.859c-.879,0-1.7-.3-1.844-.673l-.886-2.353c-.131-.352.452-.637,1.3-.637h13.138a2.406,2.406,0,0,1,1.873.637l1.236,2.353C377.87,329.578,377.316,329.879,376.437,329.879Z",
  transform: "translate(-156.593 -315.028)",
  fill: "url(#bm)"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M385.986,329.879H372.408a2.589,2.589,0,0,1-1.975-.673l-1.343-2.353c-.2-.352.328-.637,1.176-.637H383.4a2.866,2.866,0,0,1,2,.637l1.692,2.353C387.359,329.578,386.865,329.879,385.986,329.879Z",
  transform: "translate(-144.289 -315.028)",
  fill: "url(#bm)"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M395.542,329.879h-13.58a3.087,3.087,0,0,1-2.106-.673l-1.8-2.353c-.269-.352.2-.637,1.053-.637h13.136a3.382,3.382,0,0,1,2.122.637l2.151,2.353C396.857,329.578,396.419,329.879,395.542,329.879Z",
  transform: "translate(-131.99 -315.028)",
  fill: "url(#bm)"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M437.079,329.879H391.524a3.63,3.63,0,0,1-2.236-.673l-2.258-2.353c-.337-.352.078-.637.929-.637h44.072a4.924,4.924,0,0,1,2.427.637l3.275,2.353C438.248,329.578,437.956,329.879,437.079,329.879Z",
  transform: "translate(-119.696 -315.028)",
  fill: "url(#bm)"
});

var _ref83 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(371.506 237.485)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M278.761,303.781l105.721-5.4a4.787,4.787,0,0,0,3.724-7.46l-57.336-84.949a4.789,4.789,0,0,0-8.19.418L274.3,296.739A4.788,4.788,0,0,0,278.761,303.781Z",
  transform: "translate(-273.721 -203.865)",
  fill: "url(#by)"
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.999, -0.051, 0.051, 0.999, 49.21, 75.425)",
  fill: "#231f20",
  fontSize: 52,
  fontFamily: "Roboto-Bold, Roboto",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "!")), /*#__PURE__*/React.createElement("path", {
  d: "M280.206,282.685l83.885-4.283L318.6,211Z",
  transform: "translate(-264.795 -194.041)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.431
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(130.661 18.594)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 191.971,
  height: 76.386,
  rx: 1.455,
  fill: "#4e5683"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.799 9.804)"
}, /*#__PURE__*/React.createElement("text", {
  transform: "translate(0.004 28) rotate(0.034)",
  fill: "#fff",
  fontSize: 29,
  fontFamily: "Montserrat-Medium, Montserrat",
  fontWeight: 500,
  letterSpacing: "0.015em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "UNDER")), /*#__PURE__*/React.createElement("text", {
  transform: "translate(0.003 53.07) rotate(0.034)",
  fill: "#fff",
  fontSize: 17,
  fontFamily: "Roboto-Regular, Roboto",
  letterSpacing: "0.005em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "MAINTAINANCE"))), /*#__PURE__*/React.createElement("circle", {
  cx: 2.393,
  cy: 2.393,
  r: 2.393,
  transform: "translate(183.428 4.01)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.393,
  cy: 2.393,
  r: 2.393,
  transform: "translate(183.428 67.963)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.276,215.767a2.392,2.392,0,1,1-2.391-2.391A2.392,2.392,0,0,1,335.276,215.767Z",
  transform: "translate(-326.231 -209.365)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M335.276,242.678a2.392,2.392,0,1,1-2.391-2.393A2.392,2.392,0,0,1,335.276,242.678Z",
  transform: "translate(-326.231 -172.322)",
  fill: "#fff"
})));

var _ref84 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(178.537 437.3)",
  fill: "#3c3856",
  fontSize: 40,
  fontFamily: "Montserrat-Medium, Montserrat",
  fontWeight: 500,
  letterSpacing: "0.03em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "SORRY! WE ARE UNDER "), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 60
}, "SCHEDULED MAINTAINANCE "));

var _ref85 = /*#__PURE__*/React.createElement("text", {
  transform: "translate(19.037 64.321)",
  fill: "#542493",
  fontSize: 50,
  fontFamily: "SegoeUISymbol, Segoe UI Symbol"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "\u2983"), /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontFamily: "SegoeUI, Segoe UI"
}, "param"), /*#__PURE__*/React.createElement("tspan", {
  y: 0
}, "\u2984"));

var SvgMaintain1 = function SvgMaintain1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    ref: svgRef
  }, props), _ref2, /*#__PURE__*/React.createElement("g", {
    id: "bz",
    clipPath: "url(#ca)"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, /*#__PURE__*/React.createElement("g", {
    transform: "translate(916.109 170.479)"
  }, _ref10, /*#__PURE__*/React.createElement("g", {
    transform: "translate(325.224 179.442)"
  }, _ref11, /*#__PURE__*/React.createElement("path", {
    d: "M452.459,356.594H314.424L327.69,306.61h111.5Z",
    transform: "translate(-171.407 -4.382)",
    fill: "url(#d)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("path", {
    d: "M666.443,343.913H265.569a11.21,11.21,0,0,1-11.189-11.206l.124-47.328H677.818l-.124,47.328A11.283,11.283,0,0,1,666.443,343.913Z",
    transform: "translate(-254.064 -33.607)",
    opacity: 0.7,
    fill: "url(#g)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _ref15, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.037 335.299)"
  }, _ref16, _ref17, /*#__PURE__*/React.createElement("path", {
    d: "M630.825,331.529l-364.781-.012v10.9H630.825l.029-10.9C630.863,331.524,630.851,331.529,630.825,331.529Z",
    transform: "translate(-266.044 -305.393)",
    fill: "url(#k)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.041 2.339)",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82))), _ref83), _ref84, _ref85));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintain1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MAINTAIN 1.3d6a7293.svg";
export { ForwardRef as ReactComponent };